import CompactMainHeaderBackButton from '@/components/MainHeader/CompactMainHeaderBackButton'
import { useMainHeaderOverrides } from '@/components/MainHeader/contexts/Overrides'
import { useScreenLayout } from '@/hooks/screen'
import { useFocusEffect } from '@react-navigation/native'
import { useCallback, useMemo, useRef } from 'react'
import { BackHandler } from 'react-native'

interface OpenTabHeaderOptions {
    title: string
    onBack: () => void
}

export const useOpenTabHeader = (options?: OpenTabHeaderOptions) => {
    const layout = useScreenLayout()
    const onBackRef = useRef(options?.onBack)
    onBackRef.current = options?.onBack
    const title = options?.title
    const overrides = useMemo(
        () =>
            layout === 'compact' && title
                ? {
                      title,
                      left: <CompactMainHeaderBackButton onPress={() => onBackRef.current?.()} />,
                      right: null,
                  }
                : undefined,
        [layout, title]
    )

    useMainHeaderOverrides(overrides)
    useFocusEffect(
        useCallback(() => {
            if (!title) return

            const subscription = BackHandler.addEventListener('hardwareBackPress', () => {
                onBackRef.current?.()
                return true
            })
            return () => subscription.remove()
        }, [title])
    )
}
